import React from "react"
import autobind from "class-autobind"
import { IMultiJobsBudgetData, IJobBudgetSummary } from "../../../models"
import strings from "../../../localization/strings"
import _ from "lodash"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import { Paper, FontIcon } from "material-ui"
import AccountStore from "../../../stores/AccountStore"
import { red500 } from "material-ui/styles/colors"
import BudgetTimeSummaryTable from "../consolidated-timecard/BudgetTimeSummaryTable"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
interface IProps {
    multiJobsBudgetData: IMultiJobsBudgetData
}
interface IState {
    expandedJobBudgetItem: IJobBudgetSummary
}

export default class BudgetByJob extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            expandedJobBudgetItem: null
        }
        autobind(this)
    }

    getArrowUpIcon(variance: number) {
        return variance < 0 &&
            <FontIcon className="fa fa-arrow-up" style={{ fontSize: 12, color: red500 }} />
    }

    onSummaryCellClick(rowNumber) {
        const clickedJobBudgetItem = this.props.multiJobsBudgetData.JobBudgetData[rowNumber]
        this.setState({ expandedJobBudgetItem: this.state.expandedJobBudgetItem && this.state.expandedJobBudgetItem.JobId === clickedJobBudgetItem.JobId ? null : clickedJobBudgetItem })
        const currTop = window.scrollY
        const currLeft = window.scrollX
        window.scrollTo(currLeft, currTop)
    }

    render() {
        const noneOTPayTypeBudgetItems = this.props.multiJobsBudgetData.TotalBudgetData.BudgetData.BudgetItems ?
            this.props.multiJobsBudgetData.TotalBudgetData.BudgetData.BudgetItems.filter(i => !i.RegularTime && !i.OTTime && !i.OT2Time && i.PayTypeId) : []
        const specialPayTypeBudgetItems = this.props.multiJobsBudgetData.TotalBudgetData.BudgetData.PayTypeBudgetItems || []
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        })
        return (
            <div style={{ marginTop: 10 }}>
                <Paper zDepth={1} style={{ padding: 15 }}>
                    <span style={{ fontSize: 16, fontWeight: 600, marginLeft: 10 }}>{checkJobFieldAvailable('singular') ? `Budget By ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` :strings.Budget_By_Job}</span>
                    <Table>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn style={{ textAlign: "left", width: 75 }}>{ checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}`:strings.Job}</TableHeaderColumn>
                                <TableHeaderColumn style={{ textAlign: "left", width: 75 }}>{strings.Budget_Status}</TableHeaderColumn>
                                <TableHeaderColumn style={{ textAlign: "left" }}>{strings.TotalHours}</TableHeaderColumn>
                                <TableHeaderColumn style={{ textAlign: "left" }}>{strings.Reg_Hours}</TableHeaderColumn>
                                <TableHeaderColumn style={{ textAlign: "left" }}>{strings.OT_Hours}</TableHeaderColumn>
                                {!AccountStore.getHideOT2() &&
                                    <TableHeaderColumn style={{ textAlign: "left" }}>{strings.OT2_Hours}</TableHeaderColumn>
                                }
                                {noneOTPayTypeBudgetItems.map((i, index) =>
                                    <TableHeaderColumn key={index} style={{ textAlign: "left" }}>{i.PayTypeName}</TableHeaderColumn>
                                )}
                                <TableHeaderColumn style={{ textAlign: "left" }}>{strings.Amount}</TableHeaderColumn>
                                {specialPayTypeBudgetItems.map((i, index) =>
                                    <TableHeaderColumn key={index} style={{ textAlign: "left" }}>{i.PayTypeName}</TableHeaderColumn>
                                )}
                                <TableHeaderColumn style={{ textAlign: "left" }}>{strings.Open_Punches}</TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody showRowHover deselectOnClickaway displayRowCheckbox={false}>
                            {this.props.multiJobsBudgetData.JobBudgetData.map((item, index) => {
                                const expanded = this.state.expandedJobBudgetItem && this.state.expandedJobBudgetItem.JobId === item.JobId
                                const totalBudget = item.BudgetData.TotalBudget
                                const budgetItems = item.BudgetData.BudgetItems
                                const regBudget = budgetItems && budgetItems.find(i => i.RegularTime)
                                const otBudget = budgetItems && budgetItems.find(i => i.OTTime)
                                const ot2Budget = budgetItems && budgetItems.find(i => i.OT2Time)
                                const amountBudget = budgetItems && budgetItems.find(i => i.OnlyAmount)
                                return (
                                    <TableRow data-intercom-target={`Select${index}`} key={index} >
                                        <TableRowColumn style={{ paddingLeft: 0, paddingRight: 0 }}>
                                            <Table
                                                selectable={false}
                                                onCellClick={() => this.onSummaryCellClick(index)}
                                            >
                                                <TableBody displayRowCheckbox={false}>
                                                    <TableRow style={{ borderBottom: expanded && "solid 2px #cccccc" }}>
                                                        <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                                            {item.JobName}
                                                        </TableRowColumn>
                                                        <TableRowColumn style={{ textAlign: "left", width: 75 }}>
                                                            {this.getArrowUpIcon(item.BudgetData.TotalBudget && item.BudgetData.TotalBudget.HoursVariance)}
                                                        </TableRowColumn>
                                                        <TableRowColumn style={{ textAlign: "left" }}>
                                                            {item.BudgetData.TotalHours}
                                                        </TableRowColumn>
                                                        <TableRowColumn style={{ textAlign: "left" }}>
                                                            {this.getArrowUpIcon(regBudget && regBudget.BudgetedHours && regBudget.HoursVariance)} {item.BudgetData.RegularHours}
                                                        </TableRowColumn>
                                                        <TableRowColumn style={{ textAlign: "left" }}>
                                                            {this.getArrowUpIcon(otBudget && otBudget.BudgetedHours && otBudget.HoursVariance)} {item.BudgetData.OvertimeHours}
                                                        </TableRowColumn>
                                                        {!AccountStore.getHideOT2() &&
                                                            <TableRowColumn style={{ textAlign: "left" }} >
                                                                {this.getArrowUpIcon(ot2Budget && ot2Budget.BudgetedHours && ot2Budget.HoursVariance)} {item.BudgetData.DoubleOvertimeHours}
                                                            </TableRowColumn>
                                                        }
                                                        {noneOTPayTypeBudgetItems.map((i, index1) =>
                                                            <TableRowColumn key={index1} style={{ textAlign: "left" }}>
                                                                {(() => {
                                                                    const nonOTPayType = item.BudgetData.PayTypeTotals.find(j => j.PayTypeId === i.PayTypeId)
                                                                    const nonOTPayTypeBudget = budgetItems && budgetItems.find(j => j.PayTypeId === i.PayTypeId)
                                                                    return (
                                                                        <div>
                                                                            {this.getArrowUpIcon(nonOTPayTypeBudget && nonOTPayTypeBudget.BudgetedHours && nonOTPayTypeBudget.HoursVariance)} {nonOTPayType ? nonOTPayType.TotalHours : 0}
                                                                        </div>
                                                                    )
                                                                })()}
                                                            </TableRowColumn>
                                                        )}
                                                        <TableRowColumn style={{ textAlign: "left" }}>
                                                            {this.getArrowUpIcon(amountBudget && amountBudget.BudgetedAmount && amountBudget.AmountVariance)} {formatter.format(amountBudget ? amountBudget.ActualAmount : 0)}
                                                        </TableRowColumn>
                                                        {specialPayTypeBudgetItems.map((i, index1) =>
                                                            <TableRowColumn key={index1} style={{ textAlign: "left" }}>
                                                                {(() => {
                                                                    const specialPayTypeBudget = item.BudgetData.PayTypeBudgetItems && item.BudgetData.PayTypeBudgetItems.find(j => j.PayTypeId === i.PayTypeId)
                                                                    return (
                                                                        <div>
                                                                            {this.getArrowUpIcon(specialPayTypeBudget && specialPayTypeBudget.BudgetedHours && specialPayTypeBudget.HoursVariance)}
                                                                            <span>
                                                                                {specialPayTypeBudget ? specialPayTypeBudget.ActualHours : 0}
                                                                            </span>
                                                                        </div>
                                                                    )
                                                                })()}
                                                            </TableRowColumn>
                                                        )}
                                                        <TableRowColumn style={{ textAlign: "left" }}>
                                                            {item.OpenPunchCount}
                                                        </TableRowColumn>
                                                    </TableRow>
                                                    {this.state.expandedJobBudgetItem && this.state.expandedJobBudgetItem.JobId === item.JobId &&
                                                        <TableRow key={item.JobId}>
                                                            <TableRowColumn
                                                                colSpan={7 + (AccountStore.getHideOT2() ? 0 : 1) + noneOTPayTypeBudgetItems.length + specialPayTypeBudgetItems.length}
                                                            >
                                                                <div onClick={(e) => e.stopPropagation()} style={{ paddingLeft: 100, paddingTop: 10, paddingBottom: 25, paddingRight: 10 }}>
                                                                    <BudgetTimeSummaryTable
                                                                        consolidatedTimecardTimeSummary={item.BudgetData}
                                                                    />
                                                                </div>
                                                            </TableRowColumn>
                                                        </TableRow>
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableRowColumn>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </Paper>
            </div>
        )
    }

}